import { StyledPillButton, text } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useMetrics } from "../../hooks/useMetrics";
import { LocaleAtom } from "../../state/localeAtom";
import { CreateNewStack, ShowStacks } from "../../state/stackAtoms";

function NewStoryButton() {
  useRecoilValue(LocaleAtom); // re-render on locale change
  const setCreateNewStack = useSetRecoilState(CreateNewStack);
  const setShowStacks = useSetRecoilState(ShowStacks);
  const { track } = useMetrics();

  const handleClick = () => {
    setShowStacks(true);
    setCreateNewStack(true);
    // intent only — story_created fires in useCreateStack on success
    track('story_create_opened');
  };

  return (
    <StyledPillButton $variant="primaryOutline" onClick={handleClick}>
      {text.controls.newStack}
    </StyledPillButton>
  );
}

export default NewStoryButton;
